import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import SEO from '../components/seo'
import Header from '../components/header'
import Footer from '../components/footer'
import api from '../api/api.json'

// import Favicon from '../images/favicon.png'

import './index.css'

const Layout = ({ location, children, data }) => (
  
  <div>
    <Header siteTitle={data.site.siteMetadata.title} location={location} headerData={data.headerComponentData.headers} />
    <div
      style={{
        margin: '0 auto',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
    <Footer api={api} footerData={data.footerComponentData.cities}/>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    },
    footerComponentData {
      cities {
        id
        neigh
        phone
        street
        title
      }
    },
    headerComponentData {
      headers {
        bgImage
        bgImage2
        headerLead
        id
        lead1
        lead2
        metaDescription
        metaTitle
        path
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js